// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kanban-board-container[data-v-4a93e3ba]{background-color:#fff;position:relative}.kanban-board-container .kanban-filters-container[data-v-4a93e3ba]{background-color:#fff;padding:0 10px;margin:20px 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
